import { array } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { TRoadblockEvidenceFact, TRoadblockEvidenceLink } from "../../codecs/form/RoadblockForm";
import { TUserCaseUserType, UserCaseUserType_UserCaseUserTypeDisplayName } from "../../codecs/UserCaseUserType";
import { formatDate } from "../../../shared/src/utilsByDomain/dateTime";
import { TRoadblockClient } from "../roadblockTypesAndCodecs";

export const formatEvidenceDate = (iso: string): string => formatDate(iso, "d MMM yyyy");

export const clientName = (client: TRoadblockClient): string => {
    const name = `${client.first_name} ${client.last_name}`.trim();
    return name.length > 0 ? name : UserCaseUserType_UserCaseUserTypeDisplayName(client.user_type);
};

export const clientsOfTypes = (
    clients: Array<TRoadblockClient>,
    userTypes: Array<TUserCaseUserType>,
): Array<TRoadblockClient> =>
    pipe(clients, array.filter((client) => userTypes.includes(client.user_type)));

export const fact = (
    label: string,
    value: string,
    isPresent: boolean,
    link: TRoadblockEvidenceLink | null = null,
): TRoadblockEvidenceFact => ({
    label,
    value,
    status: isPresent ? "present" : "missing",
    link,
});

export const neutralFact = (
    label: string,
    value: string,
    link: TRoadblockEvidenceLink | null = null,
): TRoadblockEvidenceFact => ({ label, value, status: "neutral", link });
